import { render, staticRenderFns } from "./configuracaoRotuloUsuario.vue?vue&type=template&id=45c05e06"
import script from "./configuracaoRotuloUsuario.ts?vue&type=script&lang=js&external"
export * from "./configuracaoRotuloUsuario.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c05e06')) {
      api.createRecord('45c05e06', component.options)
    } else {
      api.reload('45c05e06', component.options)
    }
    module.hot.accept("./configuracaoRotuloUsuario.vue?vue&type=template&id=45c05e06", function () {
      api.rerender('45c05e06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/rotulopersonalizado/configuracaoRotuloUsuario.vue"
export default component.exports